import styled, { css } from 'styled-components';

interface Props {
  sticky?: boolean;
  layer?: number;
  top: number;
}

/**
 * @param sticky {boolean} - To make the children sticky
 * @param top {number} - Distance from top
 * @param layer {number} - Z-index layer, check variables.css
 */
export const StickyWrapper = styled.div<Props>`
  ${({ layer }) => css`
    z-index: var(--zindex-layer-${`0${layer || '0'}`});
  `};
  background: var(--white-100);
  position: relative;
  transition: top var(--animation-duration-medium) ease;

  &[style] {
    ${({ sticky, top }) =>
      !!sticky &&
      css`
        top: ${top}px !important;
      `};
  }
`;
